import React from 'react';
export function LavaLampBackground() {
  return <div className="fixed inset-0 overflow-hidden pointer-events-none" style={{
    zIndex: 0
  }} data-id="element-121">
      {/* Blue blob 1 - large, slow */}
      <div className="absolute w-[600px] h-[600px] rounded-full opacity-30" style={{
      background: 'radial-gradient(circle, var(--blue) 0%, transparent 70%)',
      filter: 'blur(80px)',
      top: '10%',
      left: '5%',
      animation: 'lava-float-1 25s ease-in-out infinite'
    }} data-id="element-122" />

      {/* Neon blob 1 - medium */}
      <div className="absolute w-[500px] h-[500px] rounded-full opacity-25" style={{
      background: 'radial-gradient(circle, var(--neon) 0%, transparent 70%)',
      filter: 'blur(70px)',
      top: '60%',
      right: '10%',
      animation: 'lava-float-2 30s ease-in-out infinite'
    }} data-id="element-123" />

      {/* Blue blob 2 - medium, faster */}
      <div className="absolute w-[450px] h-[450px] rounded-full opacity-25" style={{
      background: 'radial-gradient(circle, var(--blue) 0%, transparent 70%)',
      filter: 'blur(75px)',
      bottom: '15%',
      left: '15%',
      animation: 'lava-float-3 20s ease-in-out infinite'
    }} data-id="element-124" />

      {/* Neon blob 2 - small, medium speed */}
      <div className="absolute w-[400px] h-[400px] rounded-full opacity-20" style={{
      background: 'radial-gradient(circle, var(--neon) 0%, transparent 70%)',
      filter: 'blur(65px)',
      top: '40%',
      left: '40%',
      animation: 'lava-float-4 28s ease-in-out infinite'
    }} data-id="element-125" />

      {/* Blue blob 3 - large, very slow */}
      <div className="absolute w-[550px] h-[550px] rounded-full opacity-20" style={{
      background: 'radial-gradient(circle, var(--blue) 0%, transparent 70%)',
      filter: 'blur(85px)',
      top: '30%',
      right: '5%',
      animation: 'lava-float-5 35s ease-in-out infinite'
    }} data-id="element-126" />

      {/* Neon blob 3 - small accent */}
      <div className="absolute w-[350px] h-[350px] rounded-full opacity-15" style={{
      background: 'radial-gradient(circle, var(--neon) 0%, transparent 70%)',
      filter: 'blur(60px)',
      bottom: '25%',
      right: '30%',
      animation: 'lava-float-6 22s ease-in-out infinite'
    }} data-id="element-127" />
    </div>;
}